import { render, staticRenderFns } from "./Impressao.vue?vue&type=template&id=5ed5226e&scoped=true"
import script from "./Impressao.vue?vue&type=script&lang=js"
export * from "./Impressao.vue?vue&type=script&lang=js"
import style0 from "./Impressao.vue?vue&type=style&index=0&id=5ed5226e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5226e",
  null
  
)

export default component.exports